module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.entidadeUsu.companyName),
      expression: "!entidadeUsu.companyName"
    }],
    staticClass: "box-header with-border",
    attrs: {
      "ssm-lte-loading": "cmptSimpleRegisterEntityForm",
      "ng-hide": "$ctrl.entity.status === 'PENDENTE_APROVACAO'  ||  $ctrl.entity.status === 'COMPLETO' || $ctrl.entity.status =='INCOMPLETO'"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidadeEdital.noticeNumber),
      expression: "entidadeEdital.noticeNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Razão social",
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "name": "Razão social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidadeEdital.noticeNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidadeEdital, "noticeNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "Entidade"
    }
  }, [(_vm.procSelecionado) ? _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "dadosCadastrais"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7 col-lg-6",
    attrs: {
      "id": "cadastroJuri"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidadeUsu.companyName),
      expression: "entidadeUsu.companyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Razão social",
    staticClass: "form-control",
    attrs: {
      "name": "Razão social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidadeUsu.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidadeUsu, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CNPJ')
    }
  }, [_c('label', {
    ref: "CNPJ",
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "CNPJ"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14|max:14'),
      expression: "'required|min:14|max:14'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ",
      "type": "text",
      "mask": "NN.NNN.NNN/NNNN-##",
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.entidadeUsu.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.entidadeUsu, "cnpj", $$v)
      },
      expression: "entidadeUsu.cnpj"
    }
  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cnpjExpeditionTime')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "cnpjExpeditionTime"
    }
  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidadeUsu.cnpjExpeditionTime),
      expression: "entidadeUsu.cnpjExpeditionTime"
    }],
    ref: "cnpjExpeditionTime",
    staticClass: "form-control",
    attrs: {
      "name": "cnpjExpeditionTime",
      "type": "date",
      "format": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.entidadeUsu.cnpjExpeditionTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidadeUsu, "cnpjExpeditionTime", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nome fantasia')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "Nome fantasia"
    }
  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidadeUsu.businessName),
      expression: "entidadeUsu.businessName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Nome fantasia",
    staticClass: "form-control",
    attrs: {
      "name": "Nome fantasia",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidadeUsu.businessName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidadeUsu, "businessName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Natureza jurídica')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "Natureza jurídica"
    }
  }, [_vm._v("Natureza jurídica:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidadeUsu.legalType),
      expression: "entidadeUsu.legalType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "Natureza jurídica",
    staticClass: "form-control",
    attrs: {
      "name": "Natureza jurídica"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entidadeUsu, "legalType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ASSOCIAÇÃO"
    }
  }, [_vm._v("Associação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "COOPERATIVA"
    }
  }, [_vm._v("Cooperativa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EMPRESA_PUBLICA"
    }
  }, [_vm._v("Empresa pública")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FUNDACAO"
    }
  }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ORGAO_PUBLICO_EXECUTIVO_ESTADUAL"
    }
  }, [_vm._v("Orgão público executivo estadual")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ORGAO_PUBLICO_EXECUTIVO_MUNICIPAL"
    }
  }, [_vm._v("Orgão público executivo municipal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SEM_FINS_LUCRATIVOS"
    }
  }, [_vm._v("Sem fins lucrativos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SERVICO_SOCIAL_AUTONOMO"
    }
  }, [_vm._v("Serviço social autônomo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOCIEDADE_LTDA"
    }
  }, [_vm._v("Sociedade ltda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOCIEDADE_POR_ACOES"
    }
  }, [_vm._v("Sociedade por Ações")])]), _vm._v(" "), (_vm.errors.first('Natureza jurídica')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Natureza jurídica é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Ramo atividade')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "Ramo atividade"
    }
  }, [_vm._v("Ramo atividade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidadeUsu.activity),
      expression: "entidadeUsu.activity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "Ramo atividade",
    staticClass: "form-control",
    attrs: {
      "name": "Ramo atividade"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entidadeUsu, "activity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.ramoAtividade), function(ramoAtividade) {
    return _c('option', {
      attrs: {
        "label": ramoAtividade.code + ' - ' + ramoAtividade.description
      },
      domProps: {
        "value": ramoAtividade
      }
    }, [_vm._v(_vm._s(ramoAtividade.code + ' - ' + ramoAtividade.description))])
  }), 0), _vm._v(" "), (_vm.errors.first('Ramo atividade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Ramo atividade é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Doc. constituição')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-4 col-md-3",
    attrs: {
      "for": "constitutionDocument"
    }
  }, [_vm._v("Doc. constituição:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidadeUsu.constitutionDocument),
      expression: "entidadeUsu.constitutionDocument"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "Doc. constituição",
    staticClass: "form-control",
    attrs: {
      "name": "Doc. constituição"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entidadeUsu, "constitutionDocument", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ATA_CONSTITUICAO"
    }
  }, [_vm._v("Ata constituição")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CONTRATO_SOCIAL"
    }
  }, [_vm._v("Contrato social")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ESTATUTO"
    }
  }, [_vm._v("Estatuto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LEI_ORGANICA_MUNICIPAL"
    }
  }, [_vm._v("Lei orgânica municipal")])]), _vm._v(" "), (_vm.errors.first('Doc. constituição')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Doc. constituição é obrigatório')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-7",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Telefone Fixo: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "name": "Telefone"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.entidadeUsu.contact.phone),
      callback: function($$v) {
        _vm.$set(_vm.entidadeUsu.contact, "phone", $$v)
      },
      expression: "entidadeUsu.contact.phone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-7"
  }, [_c('label', {
    staticClass: "col-md-4",
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("Telefone Celular:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "name": "celular"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidadeUsu.contact.mobile),
      expression: "entidadeUsu.contact.mobile"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(##) #####-#####'),
      expression: "'(##) #####-#####'"
    }],
    staticClass: "form-control",
    attrs: {
      "masked": _vm.masked,
      "name": "mobile",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidadeUsu.contact.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidadeUsu.contact, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-7",
    class: {
      'has-error': _vm.errors.first('email')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    attrs: {
      "name": "email"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidadeUsu.contact.email),
      expression: "entidadeUsu.contact.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.entidadeUsu.contact.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidadeUsu.contact, "email", $event.target.value)
      }, function($event) {
        _vm.entidadeUsu.contact.email = $event.target.value.toLowerCase()
      }]
    }
  })]), _vm._v(" "), (_vm.errors.first('email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('email')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('endereco', {
    attrs: {
      "entEnderecos": _vm.entidadeUsu.address
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(4), _vm._v(" "), _c('dirigentes', {
    attrs: {
      "entDirigentes": _vm.entidadeUsu.chiefs,
      "name": "dirigentes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.entidadeUsu.documents,
      "documentTypes": _vm.documentosObrigatorios,
      "documentosObrigatorios": _vm.documentosObrigatorios
    }
  })], 1)])])])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "Proposta"
    }
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('nome da proposta')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "nome da proposta"
    }
  }, [_vm._v("Nome do Projeto:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.name),
      expression: "propostaSimplificada.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome da proposta",
      "id": "nome da proposta",
      "type": "text"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome da proposta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome da proposta')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('nome do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.coordinatorName),
      expression: "propostaSimplificada.coordinatorName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome do coordenador",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.coordinatorName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "coordinatorName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('cpf do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorCpf",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf do coordenador",
      "type": "text",
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.propostaSimplificada.coordinatorCpf),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "coordinatorCpf", $$v)
      },
      expression: "propostaSimplificada.coordinatorCpf"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('email do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorEmail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.coordinatorEmail),
      expression: "propostaSimplificada.coordinatorEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|max:255'),
      expression: "'required|email|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email do coordenador",
      "type": "email",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.coordinatorEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "coordinatorEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('Telefone')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "tel",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.propostaSimplificada.coordinatorPhone),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "coordinatorPhone", $$v)
      },
      expression: "propostaSimplificada.coordinatorPhone"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('Telefone Celular')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Celular",
      "type": "tel",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.propostaSimplificada.coordinatorMobile),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "coordinatorMobile", $$v)
      },
      expression: "propostaSimplificada.coordinatorMobile"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone Celular')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Celular')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required",
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('COORDINATORPHONE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Fax",
      "type": "tel",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.propostaSimplificada.coordinatorFax),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "coordinatorFax", $$v)
      },
      expression: "propostaSimplificada.coordinatorFax"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    attrs: {
      "form-horizontal": ""
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
    staticClass: " col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('Data Inicial')
    },
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data inicial ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.initialDate",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "Data Inicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.propostaSimplificada.initialDate),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "initialDate", $$v)
      },
      expression: "propostaSimplificada.initialDate"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('periodo')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('PERIODS')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.periods",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.periods),
      expression: "propostaSimplificada.periods"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1'),
      expression: "'required|min_value:1'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
    attrs: {
      "lang": "pt-br",
      "name": "periodo",
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.periods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "periods", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_vm._v(_vm._s(_vm.dataFinal))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Informações introdutórias")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('presentation')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "presentation"
    }
  }, [_vm._v(" Apresentação ")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.presentation),
      expression: "propostaSimplificada.presentation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "presentation",
      "id": "presentation",
      "rows": "5",
      "cols": "12",
      "placeholder": 'DESCREVA, DE FORMA SUCINTA, A ÁREA DE ATUAÇÃO E AÇÕES DESENVOLVIDAS PELA ENTIDADE.'
    },
    domProps: {
      "value": (_vm.propostaSimplificada.presentation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "presentation", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('presentation')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('presentation')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "form-group "
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('objetivo geral')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "objetivo geral"
    }
  }, [_vm._v(" Objetivo Geral ")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.generalObjective),
      expression: "propostaSimplificada.generalObjective"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "objetivo geral",
      "id": "objetivo geral",
      "rows": "5",
      "cols": "10",
      "placeholder": 'Defina de forma sucinta o que se pretende alcançar com o projeto. O objetivo geral deve refletir a transformação desejada pela sua organização, levando em consideração o problema apresentado e a solução proposta. Ele deve ser passível de ser alcançado por meio dos objetivos específicos e as atividades propostas. O objetivo deve ser iniciado com um verbo no infinitivo, exemplo: elevar, aprimorar, fortalecer, transformar, etc.'
    },
    domProps: {
      "value": (_vm.propostaSimplificada.generalObjective)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "generalObjective", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('objetivo geral')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('objetivo geral')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('resumo')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "resumo"
    }
  }, [_vm._v(" Justificativa ")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.justification),
      expression: "propostaSimplificada.justification"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justification",
      "id": "resumo",
      "rows": "5",
      "cols": "10",
      "placeholder": 'QUAL O PROBLEMA QUE A SUA ORGANIZAÇÃO QUER RESOLVER? Descreva aqui o problema que a sua organização quer solucionar. Utilize os tópicos abaixo para orientar seu texto: - Qual é a situação-problema a ser solucionado? - Quais as suas origens? - Quais os fatores sociais, políticos, ambientais e culturais que o agravam? - Quais são as consequências desse problema para a região e para o público alvo da proposta?  - Quem serão as pessoas atendidas pelo projeto?\\n\\n O QUE A SUA ORGANIZAÇÃO PRETENDE FAZER PARA SOLUCIONAR O PROBLEMA APRESENTADO?\\n\\n Descreva aqui o que a sua organização apresenta como alternativa de solução. Utilize os tópicos abaixo para orientar seu texto:\\n \\n - O quê sua instituição propõe como solução?\\n - Quais são as atividades propostas?\\n - Como as atividades propostas contribuem para a solução do problema?'
    },
    domProps: {
      "value": (_vm.propostaSimplificada.justification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "justification", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('resumo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('resumo')))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_vm._m(7), _vm._v(" "), _c('publico-alvo', {
    attrs: {
      "propsPublicosGrid": _vm.propostaSimplificada.audiences
    },
    on: {
      "publicoAlvoAdicionado": function($event) {
        _vm.propostaSimplificada.audiences = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(8), _vm._v(" "), _c('equipe-projeto', {
    attrs: {
      "propsEquipes": _vm.propostaSimplificada.teams
    },
    on: {
      "equipeAdicionada": function($event) {
        _vm.propostaSimplificada.teams = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Resultados esperados')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "results"
    }
  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.results",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.results),
      expression: "propostaSimplificada.results"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Resultados esperados",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.results)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "results", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Resultados esperados')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Resultados esperados')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Operacionalização')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.operation",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.operation),
      expression: "propostaSimplificada.operation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Operacionalização",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.operation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "operation", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Operacionalização')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Operacionalização')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('Parceria')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "partner"
    }
  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.partner",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.partner),
      expression: "propostaSimplificada.partner"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Parceria",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.partner)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "partner", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Parceria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Parceria')))]) : _vm._e()])])])])])]), _vm._v(" "), _c('label', [_vm._v("Listagem de Tecnologias Sociais, conforme mencionado no campo operacionalização, acima.")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "target": "_blank",
      "href": "https://projetos.fbb.org.br/docs/ListaTS.xlsx"
    }
  }, [_vm._v("Lista de Tecnolias Sociais")]), _vm._v(" - (Faça o download do arquivo.)\n          "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('fieldset', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.entityIsExecutioner),
      expression: "propostaSimplificada.entityIsExecutioner"
    }],
    attrs: {
      "type": "radio",
      "name": "entityExecutingBool",
      "id": "proposal-entity-executing-true"
    },
    domProps: {
      "value": 'true',
      "checked": _vm._q(_vm.propostaSimplificada.entityIsExecutioner, 'true')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.propostaSimplificada, "entityIsExecutioner", 'true')
      }
    }
  }), _vm._v(" Sim\n                      ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.entityIsExecutioner),
      expression: "propostaSimplificada.entityIsExecutioner"
    }],
    attrs: {
      "type": "radio",
      "name": "entityExecutingBool",
      "id": "proposal-entity-executing-false"
    },
    domProps: {
      "value": 'false',
      "checked": _vm._q(_vm.propostaSimplificada.entityIsExecutioner, 'false')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.propostaSimplificada, "entityIsExecutioner", 'false')
      }
    }
  }), _vm._v(" Não\n                      ")])])]), _vm._v(" "), (_vm.propostaSimplificada.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field  col-md-12",
    class: {
      'has-error': _vm.errors.first('Nome Entidade Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    attrs: {
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.entityExecutingName),
      expression: "propostaSimplificada.entityExecutingName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!propostaSimplificada.entityIsExecutioner'),
      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nome Entidade Executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.entityExecutingName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "entityExecutingName", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Nome Entidade Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Nome Entidade Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Representante legal')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingProcurator",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.entityExecutingProcurator),
      expression: "propostaSimplificada.entityExecutingProcurator"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!propostaSimplificada.entityIsExecutioner'),
      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Representante legal",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.entityExecutingProcurator)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "entityExecutingProcurator", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Representante legal')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Representante legal')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CNPJ entidade executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCNPJ",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!propostaSimplificada.entityIsExecutioner|cnpj'),
      expression: "'required:!propostaSimplificada.entityIsExecutioner|cnpj'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ entidade executora",
      "type": "text",
      "mask": ['NN.NNN.NNN/NNNN-##'],
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.propostaSimplificada.entityExecutingCNPJ),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "entityExecutingCNPJ", $$v)
      },
      expression: "propostaSimplificada.entityExecutingCNPJ"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CNPJ entidade executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ entidade executora')))]) : _vm._e()])]), _vm._v(" "), _c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('E-mail executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingEmail",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.entityExecutingEmail),
      expression: "propostaSimplificada.entityExecutingEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!propostaSimplificada.entityIsExecutioner|email'),
      expression: "'required:!propostaSimplificada.entityIsExecutioner|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "E-mail executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.entityExecutingEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "entityExecutingEmail", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('E-mail executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('E-mail executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Telefone Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!propostaSimplificada.entityIsExecutioner'),
      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Executora",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.propostaSimplificada.entityExecutingPhone),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "entityExecutingPhone", $$v)
      },
      expression: "propostaSimplificada.entityExecutingPhone"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Telefone celular da executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingMobile",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!propostaSimplificada.entityIsExecutioner'),
      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone celular da executora",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.propostaSimplificada.entityExecutingMobile),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "entityExecutingMobile", $$v)
      },
      expression: "propostaSimplificada.entityExecutingMobile"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('Telefone celular da executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone celular da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingFax",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "entityExecutingFax",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.propostaSimplificada.entityExecutingFax),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "entityExecutingFax", $$v)
      },
      expression: "propostaSimplificada.entityExecutingFax"
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CEP da executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCEP",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:!propostaSimplificada.entityIsExecutioner'),
      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CEP da executora",
      "type": "text",
      "mask": ['#####-###']
    },
    model: {
      value: (_vm.propostaSimplificada.entityExecutingCEP),
      callback: function($$v) {
        _vm.$set(_vm.propostaSimplificada, "entityExecutingCEP", $$v)
      },
      expression: "propostaSimplificada.entityExecutingCEP"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('CEP da executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CEP da executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('UF executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingState",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.entityExecutingState),
      expression: "propostaSimplificada.entityExecutingState"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!propostaSimplificada.entityIsExecutioner'),
      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "UF executora"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propostaSimplificada, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "AC"
    }
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    }
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    }
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GO"
    }
  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    }
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    }
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("TO")])])]), _vm._v(" "), (_vm.errors.first('UF executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('UF executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Cidade da Executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCity",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.entityExecutingCity),
      expression: "propostaSimplificada.entityExecutingCity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!propostaSimplificada.entityIsExecutioner'),
      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Cidade da Executora",
      "type": "text"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.entityExecutingCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "entityExecutingCity", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Cidade da Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cidade da Executora')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Endereço da Executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingAddress",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propostaSimplificada.entityExecutingAddress),
      expression: "propostaSimplificada.entityExecutingAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required:!propostaSimplificada.entityIsExecutioner'),
      expression: "'required:!propostaSimplificada.entityIsExecutioner'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Endereço da Executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.propostaSimplificada.entityExecutingAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propostaSimplificada, "entityExecutingAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Endereço da Executora')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Endereço da Executora')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(11), _vm._v(" "), _c('objetivo-especifico', {
    attrs: {
      "propsObjetivos": _vm.propostaSimplificada.objectives
    },
    on: {
      "objetivoAdicionado": function($event) {
        _vm.propostaSimplificada.objectives = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(12), _vm._v(" "), _c('metas', {
    attrs: {
      "propsObjetivos": _vm.propostaSimplificada.objectives
    },
    on: {
      "metaAdicionada": function($event) {
        _vm.propostaSimplificada.objectives = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(13), _vm._v(" "), _c('atividades', {
    attrs: {
      "meses": _vm.propostaSimplificada.periods,
      "propsObjetivos": _vm.propostaSimplificada.objectives
    },
    on: {
      "metaAdicionada": function($event) {
        _vm.propostaSimplificada.objectives = $event
      }
    }
  })], 1), _vm._v(" "), _c('municipalizacao', {
    attrs: {
      "proposta": _vm.propostaSimplificada
    },
    on: {
      "municipioAdicionado": function($event) {
        _vm.propostaSimplificada = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(14), _vm._v(" "), _c('cursos', {
    attrs: {
      "propsCursos": _vm.propostaSimplificada.careers
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "teste"
    }
  }, [_c('legend', [_vm._v("Declaração")]), _vm._v(" "), _c('label', [_vm._v("Preencha a Declaração com os dados da entidade proponente conforme item 12.1.2 da Chamada.")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "target": "_blank",
      "href": "https://projetos.fbb.org.br/docs/declaracao.pdf"
    }
  }, [_vm._v("Baixar Declaração")]), _vm._v(" - (Faça o download do arquivo e após assinar, anexe no campo abaixo.)\n            "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.propostaSimplificada.documents,
      "documentTypes": '',
      "documentosObrigatorios": ''
    }
  })], 1)])])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.conclui()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.atualiza()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Processo: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', [_c('a', {
    staticClass: "btn btn-flat active",
    attrs: {
      "id": "tabEntidade",
      "href": "#Entidade",
      "data-toggle": "tab"
    }
  }, [_vm._v(" Entidade ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-flat",
    attrs: {
      "href": "#Proposta",
      "data-toggle": "tab"
    }
  }, [_vm._v(" Proposta ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da Entidade: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Endereço:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dirigentes:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Upload")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da Proposta: ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Público-alvo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Equipe do Projeto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Informações Gerais")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Entidade executora")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Objetivo Específico")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Metas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Atividades")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cursos")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-642559e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/entidade/EntidadePropostaEdital.vue
// module id = 1986
// module chunks = 1